import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { endOfDay, formatISO, startOfDay } from 'date-fns';

const DEFAULT_PAGE_SIZE = 30;

export default class LocationOverviewVisitorLogController extends Controller {
  queryParams = [
    'endDate',
    'locationIds',
    'pageNumber',
    'pageSize',
    'query',
    'signedOut',
    'sortBy',
    'sortDirection',
    'startDate',
  ];

  pageSize = DEFAULT_PAGE_SIZE;

  @tracked locationIds? = '';
  @tracked pageNumber = 1;
  @tracked query? = '';
  @tracked signedOut?: string;

  @tracked loadingData = true;
  @tracked startDate = formatISO(startOfDay(new Date()));
  @tracked endDate = formatISO(endOfDay(new Date()));
  @tracked sortBy?: string;
  @tracked sortDirection?: string;
}
